import EvStationIcon from '@mui/icons-material/EvStation';
import React from 'react';
import { ChargePoint } from '../../../../../../app/ApiGen';
import { ChargePointAvatar } from '../../../../../../components/Avatar/ChargePoint';
import { ContainerHeader, HeaderSection, Separator } from '../../../../../../design-system';
import { Normalised } from '../../../../../../utils/request';

export const MenuError: React.FC<{ chargePoint: Normalised<ChargePoint> | undefined }> = ({ chargePoint }) => (
  <>
    <HeaderSection>
      {() => (
        <ContainerHeader
          avatar={
            <ChargePointAvatar>
              <EvStationIcon />
            </ChargePointAvatar>
          }
          text={chargePoint?.name ?? 'Unknown'}
          subText="Charge point"
        />
      )}
    </HeaderSection>
    <Separator mb={1} />
  </>
);
